import { render, staticRenderFns } from "./MasterQuestionType.vue?vue&type=template&id=09920c06&scoped=true&"
import script from "./MasterQuestionType.vue?vue&type=script&lang=js&"
export * from "./MasterQuestionType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09920c06",
  null
  
)

export default component.exports